export default function clamp(min, val, max) {
  return Math.min(Math.max(min, val), max);
}



// WEBPACK FOOTER //
// /Users/jamess/webdev/react-projects/materialish/docs/src/vendor/react-over/compute-position/clamp.js